const config = {
  apiRoot: parse(process.env.VUE_APP_API_ROOT, 'API_ROOT_NOT_SET'),
  webRoot: parse(process.env.VUE_APP_WEB_ROOT, 'WEB_ROOT_NOT_SET'),
  paymentUrl: parse(process.env.VUE_APP_PAYMENT_URL, 'PAYMENT_URL_NOT_SET'),
  passportTypes: process.env.VUE_APP_PASSPORT_TYPES.split(','),
  features: {
    test: 'test'
  }
}

function feature (name) {
  return config.features[name]
}

function parse (value, fallback) {
  if (typeof value === 'undefined') {
    return fallback
  }
  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}

export {
  config
}

export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.feature = feature
    Vue.prototype.$appConfig = config
    Vue.prototype.$feature = feature
  }
}
